import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Icons } from '@ohif/ui-next';
import { useAppConfig } from '@state';
import ErrorScreen from './ErrorScreen';

const NotFoundStudy = () => {
  const { t } = useTranslation('NotFound');
  const [appConfig] = useAppConfig();
  const { showStudyList } = appConfig;

  return (
    <ErrorScreen
      illustration={<Icons.IllustrationNotFound />}
      title={t('Study not found')}
    >
      <p data-cy="study-not-found-message">
        {t('One or more of the requested studies are not available at this time.')}
      </p>
      {showStudyList && (
        <p
          className="mt-2"
          data-cy="return-to-study-list-message"
        >
          <Trans
            t={t}
            i18nKey="Return to the <lnk>study list</lnk> to select a different study to view."
            components={{
              lnk: (
                <Link
                  className="text-highlight hover:underline"
                  to="/"
                />
              ),
            }}
          />
        </p>
      )}
    </ErrorScreen>
  );
};

export default NotFoundStudy;
